import React from "react";

/**
 * KrishnaLoop — silent 8-second cinematic loop of Krishna in his office.
 * Two variants:
 *   • variant="backdrop" — full-bleed atmosphere layer for hero sections.
 *                          Very low opacity + blur so text stays hero.
 *   • variant="avatar"   — small circular looping portrait for quote cards,
 *                          testimonials, or confirmation moments.
 *
 * Uses <video autoplay muted loop playsinline> so it works on mobile Safari.
 * Sources both WebM (smaller) and MP4 (universal); browsers pick the lighter.
 */
export default function KrishnaLoop({ variant = "backdrop", className = "", size = 96 }) {
  if (variant === "avatar") {
    return (
      <div
        className={`relative rounded-full overflow-hidden ${className}`}
        style={{
          width: size,
          height: size,
          border: "1px solid rgba(201,169,97,0.5)",
          boxShadow: "0 12px 30px -12px rgba(201,169,97,0.4)",
        }}
        data-testid="krishna-loop-avatar"
      >
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/video/krishna-hero-poster.jpg"
          aria-hidden="true"
          className="w-full h-full object-cover"
        >
          <source src="/video/krishna-hero-loop.webm" type="video/webm" />
          <source src="/video/krishna-hero-loop.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  // Backdrop variant (default): quiet, cinematic, sits behind hero content.
  return (
    <>
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster="/video/krishna-hero-poster.jpg"
        aria-hidden="true"
        data-testid="krishna-loop-backdrop"
        className={`absolute inset-0 w-full h-full object-cover pointer-events-none ${className}`}
        style={{ opacity: 0.13, mixBlendMode: "screen", filter: "saturate(0.8) contrast(1.05) blur(1.5px)" }}
      >
        <source src="/video/krishna-hero-loop.webm" type="video/webm" />
        <source src="/video/krishna-hero-loop.mp4" type="video/mp4" />
      </video>
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 90% 70% at 50% 45%, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.8) 65%, transparent 100%)",
        }}
      />
    </>
  );
}
